// @ts-nocheck
import React from 'react';
import { Card, Typography, Box, Stack } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';
import Iconify from '../iconify';
import { fShortenNumber } from '../../utils/formatNumber';

const StyledIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(6),
  height: theme.spacing(6),
  justifyContent: 'center',
}));

interface StatCardProps {
  title: string;
  value: number | string;
  icon: string;
  color?: 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';
  prefix?: string;
  suffix?: string;
  formatNumber?: boolean;
  sx?: object;
}

export default function StatCard({
  title,
  value,
  icon,
  color = 'primary',
  prefix = '',
  suffix = '',
  formatNumber = true,
  sx,
}: StatCardProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const palette = theme.palette[color];

  const displayValue = formatNumber && typeof value === 'number' ? fShortenNumber(value) : value;

  return (
    <Card
      sx={{
        py: 3,
        px: 3,
        boxShadow: 0,
        textAlign: 'center',
        bgcolor: isDark ? alpha(palette.main, 0.15) : palette.lighter,
        ...sx,
      }}
    >
      <StyledIcon
        sx={{
          margin: 'auto',
          mb: 2,
          color: isDark ? palette.light : palette.dark,
          backgroundImage: `linear-gradient(135deg, ${alpha(isDark ? palette.light : palette.dark, 0)} 0%, ${alpha(
            isDark ? palette.light : palette.dark,
            0.24
          )} 100%)`,
        }}
      >
        <Iconify icon={icon} width={28} height={28} />
      </StyledIcon>

      <Typography variant="h4" sx={{ color: isDark ? '#ffffff' : palette.darker }}>
        {prefix}
        {displayValue}
        {suffix}
      </Typography>

      <Typography variant="subtitle2" sx={{ opacity: 0.72, color: isDark ? palette.light : palette.darker }}>
        {title}
      </Typography>
    </Card>
  );
}
